import psl, { ParsedDomain } from "psl";
import { TRANSITION_SOURCE_CONFIG } from "../configs/app";

export const limitText = (text: string, char: number) => {
  let allText = text;
  const textLength = allText?.length;
  const startText = allText?.slice(0, char);
  textLength > char ? (allText = `${startText} ...`) : (allText = startText);
  return allText;
};

export const formatPhoneNumber = (value?: string) => {
  if (!value) return value;
  const phoneNumber = value?.split("-").join("").slice(0, 11);
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength > 0) {
    return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }
  return phoneNumber;
};

export const formatZipCode = (value: string) => {
  if (!value) return value;
  const zipCode = value?.split("-").join("").slice(0, 7);
  const zipCodeLength = zipCode.length;
  if (zipCodeLength === 7) {
    return zipCode.replace(/(\d{3})(\d{4})/, "$1-$2");
  }
  return zipCode;
};

export const formatFullWidthText = (text: string) => {
  return text.replace(
    /[0-9０-９`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/：；＜＝＞？＠～！＃＄％＾＆＊（）＿｛｝「」￥｜””・～ ’ 。　　、＋]/gi,
    ""
  );
};

export const convertFullSpaceToHalfSpace = (text: string) => {
  return text.replace(/[　]/gi, " ");
};

export const formatTextFurigana = (text: string) => {
  return text.replace(
    /[0-9０-９`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/：；＜＝＞？＠～！＃＄％＾＆＊（）＿｛｝「」￥｜””＋]/gi,
    ""
  );
};

export const formatUuid = (text: string) => {
  return text.replace(
    /[０-９`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/：；＜＝＞？＠～！＃＄％＾＆＊（）＿｛｝「」￥｜””＋]/gi,
    ""
  );
};

export const formatFullAlphabet = (text: string) => {
  return text.replace(
    /[0-9０-９`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/：；＜＝＞？＠～！＃＄％＾＆＊（）＿｛｝「」￥｜””＋ぁ-んァ-ン一-龥]+$/,
    ""
  );
};

export const formatHalfWidthText = (text: string) => {
  return text.replace(/[\uff01-\uff5e]/g, (character) => {
    return String.fromCharCode(character.charCodeAt(0) - 0xfee0);
  });
};

export const generateRandom = (length: number) => {
  let string = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    string += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return string;
};

export const removeSubDomain = (hostname: string) => {
  const MAX_TLD_LENGTH = 3;

  function isNotTLD(domain: string): boolean {
    return domain.length > MAX_TLD_LENGTH;
  }
  const parts = hostname.split(".");
  let lastNotTLDIndex = -1;
  for (let i = parts.length - 1; i >= 0; i--) {
    if (isNotTLD(parts[i])) {
      lastNotTLDIndex = i;
      break;
    }
  }

  const canonicalHost = parts.slice(Math.max(0, lastNotTLDIndex)).join(".");

  return canonicalHost;
};

export const getDomainName = (domainName: string) => {
  if (domainName == "") {
    return "";
  }
  let domain = "";
  const hostname = new URL(domainName).hostname;

  const parsed = psl.parse(hostname);
  if ((parsed as ParsedDomain).input == "localhost") {
    domain = "localhost";
  } else {
    domain = (parsed as ParsedDomain).domain ?? "";
  }
  return domain;
};

// ponytail: jpm shares sendenkaigi.com but still needs external session_id for mypage SSO
const EXTERNAL_SESSION_HOSTS = ["jpm.sendenkaigi.com"];

export const needsExternalSession = (currentUrl: string, returnTo: string) => {
  if (!returnTo) return false;
  try {
    if (EXTERNAL_SESSION_HOSTS.includes(new URL(returnTo).hostname)) {
      return true;
    }
  } catch {
    // fall through to domain compare
  }
  return getDomainName(currentUrl) !== getDomainName(returnTo);
};

/** True when returnTo points at AdverTimes (SDK_WEB-1374 gate / returnto priority). */
export const isAdverTimesUrl = (returnTo: string | null | undefined): boolean => {
  if (!returnTo) return false;
  return TRANSITION_SOURCE_CONFIG.ADTAI.domains.some((domain) =>
    returnTo.includes(domain)
  );
};

export const getLabelsFromIds = (
  data: { label: string; value: string }[],
  ids: string[]
) => {
  return (
    data
      .filter((item) => ids.includes(item.value))
      .map((item) => item.label)
      .join(";") ?? ""
  );
};